import React from 'react';
import { CountdownTimer } from './CountdownTimer';
export function UrgencySection() {
  return <section className="py-12 px-4 bg-red-50 border-y border-red-200" data-id="element-293">
      <div className="max-w-3xl mx-auto text-center" data-id="element-294">
        <h2 className="text-2xl md:text-3xl font-bold text-[#3D2B1F] mb-6" data-id="element-295">
          Esta oferta especial con los bonos gratis{' '}
          <span className="text-red-500" data-id="element-296">desaparece pronto</span>
        </h2>
        <CountdownTimer size="lg" className="mb-6" data-id="element-297" />
        <p className="text-[#6B5344] text-lg" data-id="element-298">
          No dejes pasar esta oportunidad de llevarte todo el pack completo a
          una fracción de su valor real.
        </p>
      </div>
    </section>;
}